import { NoRowsOverlay, GroupOutlinedIcon } from '@shared/components';

export default function NoExamineeOverlay() {
  return <NoRowsOverlay icon={GroupOutlinedIcon} title='ยังไม่มีรายชื่อผู้เข้าสอบ' />;
}
